import React from 'react';

function WaterTemperatureSvg({height, color, opacity, className}) {

    const calculatedOpacity = opacity ?? {external: "0.75", internal: "0.5"}

    return (
        <svg className={className} height={height} viewBox="0 0 27 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.3212 7.8399C18.3212 3.90571 15.1206 0.702393 11.1898 0.702393C7.25893 0.702393 4.05834 3.90713 4.05834 7.8399V26.0077C2.98892 26.986 2.13527 28.1769 1.55198 29.5043C0.968689 30.8316 0.668602 32.2662 0.670912 33.7162C0.670912 39.5205 5.39192 44.2469 11.1912 44.2469C16.9905 44.2469 21.7101 39.5219 21.7101 33.7162C21.7101 30.7385 20.4578 27.9634 18.3226 26.0049V7.84276L18.3212 7.8399ZM18.8561 33.7205C18.853 35.7542 18.0442 37.7036 16.6071 39.1412C15.1699 40.5788 13.2217 41.3872 11.1898 41.3891C9.15811 41.3864 7.21042 40.5775 5.77382 39.1397C4.33722 37.7018 3.52898 35.7525 3.52634 33.7191C3.52634 31.1567 4.80429 28.8042 6.91519 27.3838V7.84276C6.91519 5.4831 8.83069 3.56025 11.1898 3.56025C13.5488 3.56025 15.4686 5.48167 15.4686 7.84276V27.3853C16.5108 28.0801 17.3653 29.0219 17.9563 30.1268C18.5472 31.2318 18.8563 32.4672 18.8561 33.7205ZM20.5819 12.662L27.0001 16.3707V8.95621L20.5819 12.662Z"
                fill={color}
                fillOpacity={calculatedOpacity.external}
            />
            <path
                d="M14.0423 28.1962V12.6621H8.33717V28.1933C6.33609 29.2326 4.95117 31.3053 4.95117 33.7178C4.97576 35.358 5.64398 36.9227 6.81151 38.0739C7.97905 39.2252 9.55219 39.8706 11.1912 39.8708C12.8302 39.871 14.4035 39.2259 15.5713 38.0749C16.7391 36.9239 17.4076 35.3594 17.4326 33.7192C17.4326 31.3067 16.0491 29.234 14.0437 28.1976L14.0423 28.1962Z"
                fill={color}
                fillOpacity={calculatedOpacity.internal}
            />
        </svg>
    );
}

export default WaterTemperatureSvg;